<template>
  <div class="message">
    <div class="messageContainer">
      <div class="messageContainer__header" >
        <p class="leftView__title">我的消息箱</p>
        <span class="back" @click="goBack()">返回</span>
      </div>
      <div class="messageContainer__content">
        <div class="messageContainer__content__leftView">
          <div class="leftView__tab1" @click="switchTab('attention')">
            <span :class="`${type === 'attention' ? 'leftView__tab__icon--arrow' : 'leftView__tab__icon'}`"></span>
            <span class="leftView__tab__text">@我的</span>
            <span class="leftView__tab__count" v-if="message && message.unread_attention_comment_count+message.unread_attention_post_count > 0">{{message.unread_attention_comment_count+message.unread_attention_post_count}}</span>
          </div>
          <div class="leftView__tab2" @click="switchTab('comment')">
            <span :class="`${type === 'comment' ? 'leftView__tab__icon--arrow' : 'leftView__tab__icon'}`"></span>
            <span class="leftView__tab__text">评论</span>
            <span class="leftView__tab__count" v-if="message && message.unread_comment_count > 0">{{message.unread_comment_count}}</span>
          </div>
          <div class="leftView__tab3" @click="switchTab('like')">
            <span :class="`${type === 'like' ? 'leftView__tab__icon--arrow' : 'leftView__tab__icon'}`"></span>
            <span class="leftView__tab__text">赞</span>
            <span class="leftView__tab__count" v-if="message && message.unread_like_count > 0">{{message.unread_like_count}}</span>
          </div>
          <div class="leftView__tab4" @click="switchTab('notification')">
            <span :class="`${type === 'notification' ? 'leftView__tab__icon--arrow' : 'leftView__tab__icon'}`"></span>
            <span class="leftView__tab__text">通知消息</span>
            <span class="leftView__tab__count" v-if="message && message.unread_notification_count > 0">{{message.unread_notification_count}}</span>
          </div>
        </div>
        <div class="messageContainer__content__rightView">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { TITLE, BG, AVATAR_BG, BRAND_ICON, IMG_BACK } from "@/assets";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { types as LoginTypes } from "@/store/modules/login";

export default {
  name: "MobileMessage",
  components: {
  },
  data() {
    return {
      images: {
        title: TITLE,
        bg: BG,
        back: IMG_BACK
      },
      type:'comment'
    };
  },
  computed: {
    ...mapState({
      message:state => state.login.message,
    }),
    ...mapGetters({})
  },

  methods: {
    ...mapMutations({}),
    ...mapActions({
      fetchUnreadMessage:LoginTypes.FETCH_UNREAD_MESSAGE,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
    }),
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      }else if(window.history.length === 1){
        if (location.origin.includes("coding61.com")) {
          location.href = "https://www.coding61.com/index/CogaSelect";
        } else {
          location.href = "https://app.bcjiaoyu.com/index/CogaSelect";
        }
      }
    },
    //切换路由
    switchTab(type){
      // this.fetchUnreadMessage();
      this.type = type;
      this.$router.replace(`/mobilemessage/${type}`);
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    if(this.$route.name){
      this.type = this.$route.name;
    }
    this.fetchOwnInfo();
  }
};
</script>

<style>
#app{
  background-color: #f2f2f5;
}
.messageContainer__header{
  background-color: #6b45e1;
}
.messageContainer__header .leftView__title{
  font-size: 18px;
  text-align: center;
  padding: 12px;
  color: #ffffff;
}
.messageContainer__header .back{
  font-size: 15px;
  background: #ffffff;
  color: #FF7B00;
  border-radius: 15px;
  border-style: solid;
  border-width: 1px;
  padding: 2px 8px;
  position: absolute;
  left:8px;
  top:14px;
}
.messageContainer__content__leftView{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
}
.leftView__tab1,
.leftView__tab2,
.leftView__tab3,
.leftView__tab4{
  color: #333333;
  display: block;
  height: 34px;
  line-height: 34px;
  font-size: 12px;
  /* padding: 0 0 0 13px; */
  text-decoration: none;
  overflow: hidden;
  /* position: relative; */
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.leftView__tab__text{
  font-size: 14px;
}
.leftView__tab:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.leftView__tab__icon {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #6b45e1;
  margin: 0 10px 0 6px;
  display: inline-block;
}
.leftView__tab__icon--arrow {
  width: 6px;
  height: 9px;
  border: solid 2px #6b45e1;
  margin: -4px 8px 0 6px;
  background-color: transparent;
  display: inline-block;
  transform: rotate(45deg);
  border-left: none;
  border-top: none;
}
</style>
<!-- <style scoped>
.message {
  background-color: #6b45e1;
  width: 100%;
  min-width: 1100px;
  /* height: 100%; */
  min-height: 100%;

  /* background-position: center; */
  /* background-repeat: no-repeat; */
  background-size: 100%;
}
.messageContainer {
  width: 1000px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 100%;
  /* height: 100%; */
  /* display: flex;
  flex-direction: column; */
}
.messageContainer__header {
  color: #ff6600;
  /* text-align: center; */
  height: 44px;
  line-height: 44px;
  margin-bottom: 30px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.back {
  height: 44px;
  cursor: pointer;
}
.messageContainer__content {
  width: 100%;
  min-height: 680px;
  /* background-color: rgba(70, 149, 194, 1); */
  background-color: #f2f2f5;
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  border-radius: 10px;
}
.messageContainer__content__leftView {
  width: 150px;
  height: 200px;
}
.leftView__title {
  padding: 0 0 0 15px;
  color: #333333;
  display: block;
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  overflow: hidden;
}
.leftView__tab {
  font-size: 12px;
  color: #333333;
  display: block;
  height: 34px;
  line-height: 34px;
  font-size: 12px;
  padding: 0 0 0 13px;
  text-decoration: none;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.leftView__tab:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.leftView__tab__icon {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #6b45e1;
  margin: 0 10px 0 6px;
  display: inline-block;
}
.leftView__tab__icon--arrow {
  width: 6px;
  height: 9px;
  border: solid 2px #6b45e1;
  margin: -4px 8px 0 6px;
  background-color: transparent;
  display: inline-block;
  transform: rotate(45deg);
  border-left: none;
  border-top: none;
}
.leftView__tab__text {
}
.leftView__tab__count{
  margin-left: 5px;
  min-width: 18px;
    height: 13px;
    line-height: 14px;
    text-align: center;
    display: inline-block;
    padding: 0 2px;
    color: #fff;
    border-radius: 3px;
    background-color: #FF6600;
    font-size: 8px;
    position: absolute;
    right:10px;
}
.messageContainer__content__rightView {
  width: calc(100% - 160px);
  min-height: 100%;
}
</style> -->
